import TheGrid from '@/views/scorecard/excluded/grid'
import Edit from '@/views/scorecard/excluded/edit'

export default {
  path: '/scorecard/excluded',
  redirect: '/scorecard/excluded/index',
  name: 'scorecardExcluded',
  meta: {
    auth: {
      redirect: {
        name: 'scorecardExcluded.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Scorecard - Excluídos'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'scorecardExcluded.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'scorecardExcluded.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'scorecardExcluded.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
